"use strict";

exports.__esModule = true;
var react_1 = require("react");
var createDeepCompareEffect_1 = require("../factory/createDeepCompareEffect");
exports["default"] = (0, createDeepCompareEffect_1.createDeepCompareEffect)(react_1.useEffect);